import * as React from "react";
import Modal from "@mui/material/Modal";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Form, Formik } from "formik";
import theme from "../../../theme";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { StyledBox, StyledBoxFlex } from "../success-virtual-locker/style";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import CustomDropdown from "../../common/common-dropdown/CustomDropdown";
import { StyledBoxCard } from "../setting-coupon/style";
import { StyledTypography } from "../manual-split-calculation/style";
import { PERSONAL_SHOPPER_ASSIGN,} from "../../../actions/OrderAction";
import { PERSONAL_SHOPPER_DROP_DOWN_LIST } from "../../../actions/PersonalShopperActions";
import { PRODUCT_LIST } from "../../../actions/admin/customer-actions";

// Yup Validation Schema
const validationSchema = Yup.object({
});

export default function ProductAssign({ open, handleClose, isEditMode, editRecord, rowData, onSaveSuccess }) {
  const dispatch = useDispatch();
  const [initialValue, setInitialValue] = React.useState({
    status: "",
  })
  
  const productListFunc = React.useCallback(() => {
    dispatch({ type: PRODUCT_LIST, payload: {
      search : "",
      page: 1,
      limit: 10,
      onSuccess:()=>{

      }
    }});
  }, [dispatch,]);
  
  const personalShopperList = React.useCallback((data) => {
    dispatch({ type: PERSONAL_SHOPPER_DROP_DOWN_LIST, payload : {
      ...data,
      onSuccess : () => {
        // recordList();
        // handleClose();
      }
    }});

  }, [dispatch]);
  const perosnalshopperList  = useSelector((state) => state?.persionalShopData?.personalShopperDropDownList);
  const personalShoperDropdownList = perosnalshopperList?.map((single,ind)=>{
    return{
      label:single?.first_name + ' ' +single?.last_name,
      value:single?.id
    }

  })

  const personalShopperAssign = React.useCallback((data) => {
    dispatch({ type: PERSONAL_SHOPPER_ASSIGN, payload : {
      ...data,
      onSuccess : () => {
        productListFunc()
      }
    }});
  }, [dispatch, productListFunc]);

  React.useEffect(()=>{
    personalShopperList({
    page:1,
    limit:50
    })
  },[personalShopperList])
  React.useEffect(() => {
    if (isEditMode) {
      setInitialValue({
        status: editRecord?.status || "",
      })
    }
  }, [isEditMode, editRecord])
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox >
        <StyledBoxCard>
          <StyledBoxFlex>
            <StyledTypography>Assign Personal Shopper</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
          personalShopperAssign({
            personalShopperId : values?.status, 
            itemIds : [
                rowData?.id
            ]
          })
          setTimeout(() => {
            
          },2000);
          productListFunc()
          onSaveSuccess ? onSaveSuccess() : handleClose()
          }}
        >
          {({ values, errors, touched, setFieldValue, handleChange, handleBlur }) => (
            <Form>
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  {/* Status */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={personalShoperDropdownList}
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      // required
                      customLabel="Assign Personal Shopper"
                      name={`status`}
                      value={values?.status}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={
                        touched.status &&
                        Boolean(errors.status)
                      }
                      helperText={
                        touched.status &&
                        errors.status
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between" width="100%" sx={{pt:2}}>
                    <Grid item>
                      <Button variant="outlined" onClick={handleClose}>
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button variant="contained" color="primary" type="submit" disabled={!values.status}>
                        Save
                      </Button>
                    </Grid>
                  </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledBox>
    </Modal>
  );
}
